import { Slot } from '@radix-ui/react-slot';
import clsx from 'clsx';
import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  asChild?: boolean;
}

const baseStyles = 'inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';

const variants: Record<ButtonVariant, string> = {
  primary:
    'bg-accent-primary text-text-inverse hover:bg-accent-bright focus-visible:outline-accent-bright disabled:bg-accent-primary/40 disabled:text-text-muted-strong',
  secondary:
    'bg-surface-secondary text-text-primary hover:bg-surface-secondary focus-visible:outline-text-muted disabled:bg-surface-secondary disabled:text-text-muted',
  ghost:
    'bg-transparent text-text-primary hover:bg-surface-secondary focus-visible:outline-text-muted disabled:text-text-muted',
  danger:
    'bg-status-error text-text-inverse hover:bg-status-error/85 focus-visible:outline-status-error disabled:bg-status-error/40 disabled:text-text-muted-strong',
};

const Button = ({ variant = 'primary', className, asChild, ...props }: PropsWithChildren<ButtonProps>) => {
  const Component = asChild ? Slot : 'button';
  return (
    <Component
      className={clsx(baseStyles, variants[variant], className)}
      {...props}
    />
  );
};

export default Button;
